// extracted by mini-css-extract-plugin
export default {"active":"styles-module__active__src-labstep-web-core-Label-Toggle-Item-_ya0CD","item":"styles-module__item__src-labstep-web-core-Label-Toggle-Item-_LEzxC"};